
<div >
  <mat-checkbox [(ngModel)]="isChecked" class="tc-ag-grid__checkbox" [class.tc-ag-grid__checkbox--error]="isError" (change)="onChange($event)"></mat-checkbox>
</div>
